import { render, staticRenderFns } from "./Img.vue?vue&type=template&id=2aac7182&scoped=true"
import script from "./Img.vue?vue&type=script&lang=js"
export * from "./Img.vue?vue&type=script&lang=js"
import style0 from "./Img.vue?vue&type=style&index=0&id=2aac7182&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aac7182",
  null
  
)

export default component.exports